import React from 'react';

class Experience extends React.Component {

    render(){
        return (
            <div class="experience">
                <h3>{this.props.data.title} | {this.props.data.company}</h3>
                <p>{this.props.data.timeframe}</p>
                <ul>
                    {this.props.data.responsibilities.map((resp) =>
                        <li key={resp}>{resp}</li>)}
                </ul>
            </div>
        )
    }
}

export default Experience;